(function($){
  'use strict';

  class CarouselMostShopped extends HTMLElement {
    constructor() {
      super();
      setTimeout(() => {
        theme.AssetsLoader.onScrollOrUserAction(this, () => {
          this.load();
        });
      }, 0);
    }

    load() {
      this.$container = $(this);

      var _ = this,
          $carousel = this.$container.find('[data-js-carousel]'),
          $slick = $carousel.find('[data-js-carousel-slick]');

      function initialize() {
        var $prev = $carousel.find('[data-js-carousel-prev]'),
            $next = $carousel.find('[data-js-carousel-next]'),
            $arrows = $carousel.find('[data-js-carousel-arrow]'),
            count = +$carousel.attr('data-count'),
            autoplay = $carousel.attr('data-autoplay') === 'true',
            speed = +$carousel.attr('data-speed'),
            infinite = $carousel.attr('data-infinite') === 'true',
            arrows = false, // Arrows disabled
            bullets = $carousel.attr('data-bullets') === 'true';

        _.$slick = $slick;

        $slick.on('init', function () {
          $(window).trigger('checkImages');
          $carousel.removeClass('invisible');
          theme.Preloader.unset($carousel.parent());

          // Add rounded corners and gap on mobile after slick init
          $slick.find('.carousel__item img').css({
            'border-radius': '12px',
            'margin': '0 4px'
          });
        });

        $slick.slick({
          lazyLoad: false,
          arrows: arrows,
          prevArrow: $prev,
          nextArrow: $next,
          dots: bullets,
          dotsClass: 'slick-dots d-flex flex-wrap flex-center list-unstyled pt-40',
          adaptiveHeight: true,
          autoplay: autoplay,
          autoplaySpeed: speed,
          infinite: infinite,
          slidesToShow: count,
          slidesToScroll: count,
          touchMove: true,
          rtl: theme.rtl,
          responsive: [
            {
              breakpoint: theme.breakpoints.values.xl,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            },
            {
              breakpoint: theme.breakpoints.values.lg,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: theme.breakpoints.values.md,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: theme.breakpoints.values.sm,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            }
          ]
        });
      }

      if($slick.length) {
        theme.AssetsLoader.loadManually([
          ['styles', 'plugin_slick'],
          ['scripts', 'plugin_slick']
        ], function() {
          initialize();
        });
      }
    }

    disconnectedCallback() {
      if(this.$slick) {
        this.$slick.slick('destroy').off();
        this.$slick = null;
        $window.unbind('theme.resize.carousel-most-shopped');
      }
    }
  }

  theme.AssetsLoader.onPageLoaded(function() {
    customElements.define('carousel-most-shopped', CarouselMostShopped);
  });
})(jQueryTheme);
